module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/default-banner-m-4266ff9d3635b78e9ed0b48f523a01c2.png";